import axios from "axios"

const preferencesUrl = "/api/user/customer-hub/preferences"

// The caller captures the session before starting a request. Never replace it
// with a token from a later login while a request is in flight.
function options(token) {
  return { headers: { Authorization: token, "Cache-Control": "no-cache" }, timeout: 10000 }
}

export default {
  getRights: (token) => axios.get("/api/user/rights", options(token)).then((response) => response.data),
  getPreferences: (token) => axios.get(preferencesUrl, options(token)).then((response) => response.data),
  savePreferences: (preferences, token) => axios.put(preferencesUrl, preferences, options(token)).then((response) => response.data),
  getUpcomingCourses: (token = localStorage.getItem("token")) => axios.get("/api/user/customer-hub/upcoming-courses", options(token)).then((response) => response.data),
  getActivity: (params, token) => axios.get("/api/user/customer-hub/activity", { ...options(token), params }).then((response) => response.data),
}
